export default __webpack_public_path__ + "static/media/wale.c8550303.png";